import { postRequest } from "../system/server-calls";
import responseHandler from "../system/server-response-handler";

const getPaymentHistory = (data) =>
  postRequest("Payment/GetAllPaymentHistories", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

export const paymentHistoryService = {
  getPaymentHistory,
};
